var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nav"},[_c('van-nav-bar',{staticClass:"nav",attrs:{"title":_vm.title,"left-arrow":"","left-text":"返回","fixed":_vm.fixed,"right-text":_vm.righttext},on:{"click-left":_vm.onClickLeft}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }